// extracted by mini-css-extract-plugin
module.exports = {"card":"f_g","flex":"f_q"};